Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationContentProviders = void 0;
var UserNotificationType_1 = require("./UserNotificationType");
var CommentingContentProvider_1 = require("./commenting/CommentingContentProvider");
var ExtractContentProvider_1 = require("./extract/ExtractContentProvider");
var ExtractCreateContentProvider_1 = require("./extract/ExtractCreateContentProvider");
var FlowContentProvider_1 = require("./flow/FlowContentProvider");
var SharingContentProvider_1 = require("./sharing/SharingContentProvider");
function NotificationContentProviders() {
    var _a;
    return _a = {},
        _a[UserNotificationType_1.UserNotificationType.Commenting] = new CommentingContentProvider_1.CommentingContentProvider(),
        _a[UserNotificationType_1.UserNotificationType.CreateExtractFailure] = new ExtractContentProvider_1.ExtractContentProvider(),
        _a[UserNotificationType_1.UserNotificationType.FlowCompleted] = new FlowContentProvider_1.FlowContentProvider(),
        _a[UserNotificationType_1.UserNotificationType.RefreshExtractFailure] = new ExtractContentProvider_1.ExtractContentProvider(),
        _a[UserNotificationType_1.UserNotificationType.RefreshExtractSuspension] = new ExtractContentProvider_1.ExtractContentProvider(),
        _a[UserNotificationType_1.UserNotificationType.Sharing] = new SharingContentProvider_1.SharingContentProvider(),
        _a[UserNotificationType_1.UserNotificationType.CreateExtractSucceededV2] = new ExtractCreateContentProvider_1.ExtractCreateContentProvider(),
        _a;
}
exports.NotificationContentProviders = NotificationContentProviders;
//# sourceMappingURL=NotificationProviders.js.map